import type { ServiceOfferingDraft } from "./useServiceOfferingsCatalog";
import type { ServiceOffering } from "@/lib/service/types";

export function offeringToDraft(off: ServiceOffering): ServiceOfferingDraft {
  return {
    id: off.id,
    label: off.label,
    slug: off.slug,
    description: off.description,
    default_queue_id: off.default_queue_id ?? "",
    default_duration_min: off.default_duration_min != null ? String(off.default_duration_min) : "",
    base_price_dollars:
      off.base_price_cents != null ? String(off.base_price_cents / 100) : "",
    is_advertised: off.is_advertised,
    quotable_from_sales: off.quotable_from_sales,
  };
}
